import { OrderLineItem } from "../entities/OrderLineItem.ts";
import { StatusBadge, StatusKind } from "../statusBadge.tsx";
import css from "../orderDetailsPage.module.css";
import { IconInfo, Text, Tooltip } from "@idg-web-platform/pulse";
import classNames from "classnames";
import { ImageInAspectRatio } from "../../components/imageInAspectRatio/imageInAspectRatio.tsx";
import { formatAmount } from "../../utils/formats.ts";

export function renderLineItem(
  item: OrderLineItem,
  kept: boolean = true,
  showReturns: boolean = true,
) {
  const returnedStatus = {
    kind: StatusKind.Returned,
    quantity: item.quantityReturned,
    totalQuantity: item.quantity,
  };
  const quantityReturned = Number(item.quantityReturned);
  return (
    <div className={css.lineItem}>
      {showReturns && quantityReturned > 0 && (
        <div className={css.returnedItem}>
          <Tooltip text="Sobald deine Rücksendung bei uns eingegangen ist, erhältst du eine Rückerstattung über den Zahlungsweg deiner Bestellung.">
            <IconInfo />
          </Tooltip>
          <StatusBadge status={returnedStatus} bordered={false} />
        </div>
      )}

      <div
        className={classNames(
          css.productContainer,
          kept && quantityReturned == 0 ? null : css.transparent,
        )}
      >
        {item.imageUrl && (
          <ImageInAspectRatio className={css.image} src={item.imageUrl} alt={item.articleName} />
        )}
        <div className={css.content}>
          <div className={css.headline}>
            <div class={css.brandName}>{item.brandName}</div>
            <Text class={css.priceGrouped} element={"div"} removeMargin={true} fontStyle={"bold"}>
              {formatAmount(item.price)}
            </Text>
          </div>
          <div className={css.articleName}>
            <a className={css.articleName} href={item.slug}>
              {item.brandName && item.articleName.startsWith(item.brandName)
                ? item.articleName.substring(item.brandName.length)
                : item.articleName}
            </a>
          </div>
          <div className={css.lines}>
            <div className={css.line}>
              <span>Menge: {item.quantity}</span>
              {item.color && (
                <>
                  <span>Farbe: {item.color}</span>
                </>
              )}
              {item.size && (
                <>
                  <span>Größe: {item.size}</span>
                </>
              )}
            </div>
            <div className={css.line}>
              <span>Artikelnr.: {item.articleId}</span>
              <span>Einzelpreis: {formatAmount(item.price)}</span>
            </div>
          </div>
          <Text class={css.priceSingleLine} element={"div"} removeMargin={true} fontStyle={"bold"}>
            {formatAmount(item.sumPrice)}
          </Text>
        </div>
      </div>
    </div>
  );
}
